import ssoImg1 from "./../../assets/images/checklists-form-img.png"; 
import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import close from '../../assets/images/closeicon.jpeg';

function SearchInfoComponent() {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const handleSearch = () => {
    const term = searchTerm.trim();
    if (term.length >= 3) {
      navigate(`/legislation?section=search-results&searchterm=${encodeURIComponent(term)}`);
    }
  };
   const handleClear = () => {
    setSearchTerm("")
      navigate(`/legislation?section=acts-overview`);
  };
  return (
    <>
        <div className="checklists-form-wrap">
                <div className="checklists-form">
                    <div className="checklists-form-img">
                      <img src={ssoImg1} alt=""/></div>
                    <div className="checklists-form-field">
                        <div className="font-17 font-600 mb-1 text-white"></div>
                        <div className="row g-3 flex-column flex-sm-row">
                            <div className="col">
                              <div className="search-block">
                                  <input type="text" 
                                   value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                  className="form-control height-50 border-0 rounded-0" 
                                  placeholder="type your information here" />
                                  {searchTerm.length >= 1 &&
                                  <button type="button" className="btn btn-close">  
                                    <img src={close} alt="" className="" onClick={handleClear}/></button>}
                              </div>
                            </div>
                            <div className="col-auto">
                                <button type="button" 
                                onClick={handleSearch}
                                className="btn btn-submit height-50 rounded-0">Search</button>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        {/* {searchTerm?.trim().length >= 3 &&<LegislationSearchResults searchTerm={searchTerm}/>} */}
    </>
  )
}

export default SearchInfoComponent
